import { useContext, useEffect, useState } from "react";
import { Box, Button, Link, Stack, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { cartActiveSelector } from "../state/selectors/cartSelectors";
import CartService from "../services/CartService";
import { observerCartActive, cleanCart } from "../state/actions";
import { cleanUserSession, resetUserSessionDummy } from "../state/actions";
import {
  userDummySelector,
  userLoggedSelector,
} from "../state/selectors/sessionSelectors";
import { searchPaymentActive } from "../utils/searchPayment";
import { errorConection } from "../utils";
import { stl } from "../styles/base";
import LoadingContext from "../context/LoadingProvider";
import FastCard from "../components/card/FastCard";
import MessageModal from "../components/MessageModal";
import PaymentService from "../services/PaymentService";
import StoreService from "../services/StoreService";
import { STORE_ID_DEFAULT } from "../constants/businessValues";
import CartIcon from "@mui/icons-material/Shop";
import { yellow } from "@mui/material/colors";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import '../styles/fonts.css';


export const initialStateCard = [];

const PaymentList = () => {
  const [data, setData] = useState<string[]>([]);
  const [confirmSelect, setConfirmSelect] = useState({
    modal: false,
    card: [],
  });
  const { setLoadingValue } = useContext(LoadingContext);
  const userLogged = useSelector(userLoggedSelector);
  const userDummy = useSelector(userDummySelector);
  const emailLogin = userLogged?.login || userDummy?.login;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const logout = () => {
    dispatch(cleanUserSession());
    dispatch(resetUserSessionDummy());
    navigate("/");
  };

  const selectPersons = async () => {
    setLoadingValue(true);
    StoreService.enterStore(emailLogin, STORE_ID_DEFAULT, "2", "in")
      .then((res: any) => {
        const response = JSON.parse(res.result);
        if (response.msg === "OK") {
          navigate("/verify-entrance", { state: { res: res.result } });
        } else {
          toast(response.msg);
        }
      })
      .catch(() => toast("Error al abrir tienda"))
      .finally(() => setLoadingValue(false));
  };

  const cartActive = useSelector(cartActiveSelector);

  const evaluationCart = () => {
    CartService.getOrderActive(emailLogin).then((response) => {
      if (response instanceof Error) {
        dispatch(observerCartActive(false));
      } else {
        dispatch(observerCartActive(response[0]?.length > 0));
      }
    });
  };

  useEffect(() => {
    evaluationCart();
  }, []);

  useEffect(() => {
    if (!cartActive) {
      dispatch(cleanCart());
    }
  }, [cartActive]);

  const getPaymentsList = async () => {
    setLoadingValue(true);
    PaymentService.getUserPaymentMethods(emailLogin)
      .then((data) => {
        if (data instanceof Error) {
          errorConection("TypeError: Network request failed");
        } else if (data?.length) {
          const paymentActive = searchPaymentActive(data);
          !paymentActive &&
            PaymentService.updateDefaultPayment({
              id: data[0][0],
              login: emailLogin,
              state: "active",
            });
          setData(data);
        }
      })
      .finally(() => setLoadingValue(false));
  };

  const setMethodDefault = () => {
    PaymentService.updateDefaultPayment({
      id: confirmSelect.card[0],
      login: emailLogin,
      state: "active",
    })
      .then((res) => {
        res instanceof Error && errorConection("Error actualizar Tarjeta");
        getPaymentsList();
      })
      .finally(() =>
        setConfirmSelect({ modal: false, card: initialStateCard })
      );
  };

  const deletePayment = () => {
    PaymentService.deletePaymentMethod(emailLogin, confirmSelect.card[0])
      .then((res) => {
        res instanceof Error && errorConection("Error actualizar Tarjeta");
        getPaymentsList();
      })
      .catch(() =>
        toast("Error al eliminar medio de pago", { style: stl.errorStyleToast })
      )
      .finally(() => window.location.reload());
  };

  useEffect(() => {
    emailLogin ? getPaymentsList() : navigate("");
  }, []);

  return (
    <>
      <Stack>
        <Box marginBottom={2}>
          <Typography variant="h5" color="white" align="center">
            Bienvenid@
            <br />
            {userLogged?.name || "Usuari@"} 
          </Typography>
        </Box>
        <Box>
          <Typography variant="h6" color="white" align="center" marginBottom={1}>
            Podrás pagar con una tarjeta o escaneando un código QR
          </Typography>
        </Box>
        <Box width={"100%"}>
          {data.length > 0  && (
            data.map((values, index) => (
              <FastCard
                key={index}
                values={values}
                setConfirmSelect={setConfirmSelect}
              />
            ))
          )}
        </Box>
      </Stack>
      <Stack spacing={2}>
        {data.length > 0 && (
          <Link
            onClick={() =>
              navigate("/payment/new", { state: { from: "/payment/list" } })
            }
          >
          <Button variant="contained" fullWidth>
              Agregar Tarjeta
            </Button>
          </Link>
        )}
        <Box sx={{alignItems:'center'}}>
        {!cartActive && (
          <Button
            variant="contained"
            onClick={selectPersons}
            sx={{
              my: 2,
              mx: 'auto',
              display: 'block',
              backgroundColor: '#FFFF00',
              color: 'red',
              fontWeight: 'bold',
              fontSize: 18,
              fontFamily:'Arlon-Bold',
              borderRadius: '50%',
              width: '150px',
              height: '150px',
            }}
          >
            ENTRAR A RAFFINGO!
          </Button>
        )}
        </Box>

        {cartActive && (
          <Button
            variant="contained"
            fullWidth
            onClick={() => navigate("/cart")}
            startIcon={<CartIcon />}
          >
            Ver Carrito
          </Button>
        )}

        <div onClick={logout} style={style.cardBtn}>
          <Button variant="outlined" fullWidth>
            CERRAR SESIÓN
          </Button>
        </div>
      </Stack>

      <MessageModal
        type="text"
        Icon={() => {}}
        title="¿Cambiar medio de pago?"
        text={["Estas por seleccionar tu tarjeta predeterminada"]}
        actions={[
          { title: "Seleccionar", onClick: setMethodDefault },
          { title: "Eliminar", onClick: deletePayment },
        ]}
        handleClose={setConfirmSelect}
        open={confirmSelect.modal}
      />
    </>
  );
};

const style: any = {
  content: {
    display: "flex",
    flexDirection: "column",
    margin: 18,
  },
  cardBtn: {
    textDecoration: "none",
    boxShadow: "none",
  },
};

export default PaymentList;
